var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkSquareCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2h21v21H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc0081",
    fillRule: "nonzero",
    d: "M9.875 16.149L6.226 12.5l-1.242 1.234 4.891 4.891 10.5-10.5-1.234-1.234z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#ffffff",
    fillOpacity: 0.2,
    stroke: "#cc0081",
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkSquareCheckBox);
export default __webpack_public_path__ + "static/media/PinkSquareCheckBox.4a4393551f9a70a74994d38265bcf674.svg";
export { ForwardRef as ReactComponent };